import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';
import { environment } from 'environments/environment';

if (environment.production) {
    const noop = (): void => {};
    console.log = noop;
    console.debug = noop;
    console.info = noop;
    console.trace = noop;
    console.table = noop;
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err)
);
